
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emissions",
      function () {
        return require("private-next-pages/emissions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emissions"])
      });
    }
  